export type ApiError = {
  error: { code: string; message: string; fields?: Record<string, string[]> };
  requestId: string;
};
const API = `${import.meta.env.VITE_API_URL ?? ''}/api/v1`;
export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API}${path}`, {
    credentials: 'include',
    ...options,
    headers: { 'Content-Type': 'application/json', ...options?.headers },
  });
  const payload = (await response.json()) as { data: T } | ApiError;
  if (!response.ok) {
    const error = payload as ApiError;
    throw new Error(error.error?.message ?? 'Request failed.');
  }
  return (payload as { data: T }).data;
}
export const post = <T>(path: string, value?: unknown) =>
  api<T>(path, { method: 'POST', body: value === undefined ? undefined : JSON.stringify(value) });
export const put = <T>(path: string, value: unknown) =>
  api<T>(path, { method: 'PUT', body: JSON.stringify(value) });
export const patch = <T>(path: string, value: unknown) =>
  api<T>(path, { method: 'PATCH', body: JSON.stringify(value) });
